import React, { useState, useEffect } from "react";
import axios from 'axios';

import Frame from './components/Frame.js';

import GlobalStyle from "../../../styles/global.js";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import { FaBars, FaUser, FaLink } from "react-icons/fa";

import { toast, ToastContainer } from "react-toastify";
import { SlSizeFullscreen } from "react-icons/sl";
import { FaAddressCard } from "react-icons/fa6";
import { MdOutlineClose } from "react-icons/md";
import { IoMdArrowRoundBack } from "react-icons/io";

import fundo from "../../../styles/fundo.svg";
import * as FaIcons from "react-icons/fa";
import * as Fa6Icons from "react-icons/fa6";
import * as RiIcons from "react-icons/ri";
import * as LuIcons from "react-icons/lu";

import logo1 from "../../../styles/imagem/logo-1.png";
import logo2 from "../../../styles/imagem/logo-2.png";
import logo3 from "../../../styles/imagem/logo-3.png";
import logo4 from "../../../styles/imagem/logo-4.png";
import logo5 from "../../../styles/imagem/logo-5.png";

const Geral = styled.div`
  
`;

const DivExterna = styled.div`
  cursor: pointer;
  transition: transform 0.1s;
  background: ${(props) => props.currentUrl ? '#575757' : `url(${fundo}) no-repeat center/cover`};
  border-radius: ${(props) => (props.currentUrl ? '3px' : '3px')};
`;

const Div = styled.div`
  width: 98vw;
  height: 100vh;
  margin-left: 60px;

`;

const DivLayout = styled.aside`
  width: 60px;
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: ${(props) => (props.isOpen ? "300px" : "60px")};
  background-image: url(${fundo});
  color: white;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: width 0.3s;
`;

const Divbutton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const Divbuttons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  margin: 0px 0px 20px 5px;
`;

const ListItem = styled.li`
  width: 100%;
  padding: 10px 0;
  cursor: pointer;
  font-size: 18px;
  list-style-type: none;

  h4 {
    gap: 5px;
    font-size: 18px;
    padding-left: 15px;
    cursor: pointer;
    transition: transform 0.1s;
    &:hover {
      color: #11101d;
    }
  }
`;

const NestedList = styled.ul`
  
  background-color: #575757;
  list-style-type: none;
  font-size: 18px;
  padding: 5px 5px 5px 20px;
  margin-top: 10px;  // Adicionar um espaçamento entre o título e a lista

  li {
    padding: 5px 0;
    transition: transform 0.1s;
    &:hover {
      transform: scale(1.01);
      color: #11101d;
    }
  }
`;


const ListItemEst = styled.li`
  width: 100%;
  padding: 15px 10px;
  font-size: 18px;
  list-style-type: none;
  h4 {
    font-size: 18px;
    padding-left: 10px;
  }
`;

const NestedListEst = styled.ul`
  background-color: #575757;
  list-style-type: none;
  font-size: 18px;
  padding: 5px 5px 5px 20px;

  li {
    padding: 5px;
    transition: transform 0.1s;
    &:hover {
      transform: scale(1.01);
      color: #11101d;
    }
  }
  
`;

const ButtonSide2 = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  font-size: 18px;
  color: #fff;
  padding: 10px;
  gap: 10px;
  transition: transform 0.1s;

  &:hover {
    color: #11101d;
  }

`;

const ButtonSide23 = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background-color: #575757;
  font-size: 18px;
  color: #fff;
  padding: 10px;
  gap: 10px;
  transition: transform 0.1s;

  &:hover {
    color: #11101d;
  }

`;

const ToggleButton = styled.button`
  font-size: 18px;
  width: auto;
  height: 25px;
  padding:  20px 20px 5px 20px;
  margin-bottom: 20px;
  color: white;
  border: none;
  cursor: pointer;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 50px;

  .button-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  img {
    margin-left: 10px;
  }
`;






function App() {

  //--------------------------------------------------------------------------------------//
  //Ip's da api e do front
  const urlFront = process.env.REACT_APP_FRONT_URL;
  const urlApi = process.env.REACT_APP_API_URL;


  //--------------------------------------------------------------------------------------//

  //Token da api
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');




  //-----------------------------------------RECEBE OS MODULOS CADASTRADOS--------------------------//


  const [modulo, setModulo] = useState([]);
  const fetchModulo = async () => {
    try {
      const res = await axios.get(`${urlApi}gestao/modulos`, { headers: { Authorization: `Bearer ${token}` } });
      setModulo(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de modulo:', error);
    }
  };

  useEffect(() => {
    fetchModulo();
  }, [id, token]);

  //-------------------------------RECEBE OS PAGINAS CADASTRADAS------------------------------------//


  const [pagina, setPagina] = useState([]);
  const fetchPagina = async () => {
    try {
      const res = await axios.get(`${urlApi}gestao/paginas`, { headers: { Authorization: `Bearer ${token}` } });
      setPagina(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de pagina:', error);
    }
  };

  useEffect(() => {
    fetchPagina();
  }, [id, token]);


  //-------------------------------RECEBE OS ACESSOS USUARIO------------------------------------//

  const [acesso, setAcesso] = useState([]);
  const fetchAcesso = async () => {
    try {
      //const res = await axios.get(`${urlApi}acesso`, { headers: { Authorization: `Bearer ${token}` } });
      const res = await axios.post(`${urlApi}gestao/acessos-usuario`,
        { id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAcesso(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de acesso:', error);
    }
  };

  useEffect(() => {

    fetchAcesso();

  }, [id, token]);





  //-----------------------------------------MONTA A VISÂO DO SIDEBAR--------------------------//

  //Verifica quais os PBIs o usuário tem acesso

  //retorna apenas os id dos modulos
  const acessoModuloIds = acesso.map((item) => item.ID_MODULO);

  //retorna apenas os id dos pagina
  const acessoPaginaIds = acesso.map((item) => item.ID_PAGINA);

  // filtrando os itens do array modulo, mantendo apenas aqueles cujo id_modulo esteja presente no array acessoModuloIds
  const filteredModulos = modulo.filter((mod) =>
    acessoModuloIds.includes(mod.ID_MODULO)
  );


  const filteredPaginas = pagina.filter(
    (pag) =>
      acessoModuloIds.includes(pag.ID_MODULO) &&
      acessoPaginaIds.includes(pag.ID_PAGINA)
  );


  //-----------------------------------------VERIFICA O USUÀRIO--------------------------//

  // Verifica se o usuário é admin
  const [tipoUsuario, setTipoUsuario] = useState('');


  useEffect(() => {
    const fetchAcessos = async () => {
      try {
        const res = await axios.post(`${urlApi}portal/acessos-portal`,
          { id },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // Filtra o usuário pelo ID e pelo módulo "gestao"
        const usuarioFiltrado = res.data.find((usuario) => usuario.COD_MODULO === 1);
        if (usuarioFiltrado) {
          setTipoUsuario(usuarioFiltrado.TIPO_ACESSO);
        } else {
          setTipoUsuario(''); // Define um valor padrão caso não encontre o usuário
        }
      } catch (error) {
        console.error('Erro ao buscar dados de usuarios:', error);
      }
    };

    fetchAcessos(); // Chama a função de busca
  }, [id, token]);



  //-----------------------------------------ATUALIZA O FRAME COM O LINK ESCOLHIDO--------------------------//

  //Passa os links para o Frame.js redenrizar
  const [currentUrl, setCurrentUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleUrlClick = (pag) => {
    if (!pag?.URL) return;

    setLoading(true);
    setCurrentUrl(pag.URL);  // já define o URL
    handleLog(pag);
    setIsOpen(false);
  };



  //-----------------------------------------SALVA O LOG NO BANCO--------------------------//************************************* */


  const handleLog = async (pag) => {
    try {

      await axios.post(`${urlApi}gestao/log-acesso-bi`, {
        COD_FUNCIONARIO: parseInt(localStorage.getItem("id")),
        ID_MODULO: pag.ID_MODULO,
        ID_PAGINA: pag.ID_PAGINA,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });


    } catch (error) {
      console.error("Erro ao inserir log:", error);
    }
  };


  //-----------------------------------------BOTOES--------------------------//

  //Links
  const handleUsuarios = () => {
    const url = `cadastro-usuarios/`;
    window.location.href = url;
  };
  const handleEquipamentosServico = () => {
    const url = `cadastro-url/`;
    window.location.href = url;
  };
  const handleAcessos = () => {
    const url = `acessos/`;
    window.location.href = url;
  };
  const toggleInicio = () => {
    window.location.href = urlFront;
  };


  //-----------------------------------------ICONES--------------------------//


  const getIconComponent = (iconName) => {
    return (
      FaIcons[iconName] ||
      Fa6Icons[iconName] ||
      RiIcons[iconName] ||
      LuIcons[iconName] ||
      null
    );
  };


  //-----------------------------------------TOKEN DO USUÀRIO--------------------------//

  //Verifica o token do usuário
  const getToken = async () => {
    try {
      await axios.get(`${urlApi}logon/token`, { headers: { Authorization: `Bearer ${token}` } });

    } catch (error) {
      if (error.response && (error.response.status === 400 || error.response.status === 403 || error.response.status === 401)) {
        window.location.href = `${urlFront}login`;
      } else {
        console.error("Erro ao obter token:", error);
      }
    }
  };

  useEffect(() => {

    getToken();

  }, [])


  // --------- Estados de controle do sidebar e módulos ---------//

  const [isOpen, setIsOpen] = useState(false); // Controla se o sidebar está aberto ou fechado

  const toggleSidebar = () => {
    setIsOpen(!isOpen); // Alterna o estado do sidebar ao clicar no botão
  };

  const [openModules, setOpenModules] = useState({}); // Controla quais módulos estão abertos

  const toggleModule = (id) => {
    // Fecha todos os módulos, depois alterna o estado do módulo clicado
    setOpenModules((prevOpenModules) => {
      const newOpenModules = {};
      Object.keys(prevOpenModules).forEach(moduleId => {
        newOpenModules[moduleId] = false;
      });
      return {
        ...newOpenModules,
        [id]: !prevOpenModules[id], // Abre/fecha o módulo clicado
      };
    });
  };

  const handleItemClick = (id, event) => {
    toggleModule(id); // Abre ou fecha o módulo
    handleMouseEnter(id, event); // Define a posição do submenu externo baseado na posição do mouse
  };

  // --------- Estados para comportamento de hover e submenu ---------
  const [hoveredModule, setHoveredModule] = useState(null); // ID do módulo atualmente em hover
  const [isMouseOver, setIsMouseOver] = useState(null);     // Mouse sobre o módulo
  const [isMouseOverTwo, setIsMouseOverTwo] = useState(null); // Mouse sobre o submenu externo

  const [elementPosition, setElementPosition] = useState({ top: 0, left: 0 }); // Armazena posição para posicionar submenu flutuante

  const handleMouseEnter = (id, event) => {
    setIsMouseOver(true); // Marca que o mouse está sobre o item
    const rect = event.target.getBoundingClientRect(); // Pega a posição do elemento na tela
    setElementPosition({
      top: rect.top,
      left: rect.left, // Armazena a posição para posicionar o submenu flutuante
    });
    setHoveredModule(id); // Define qual módulo está em foco
  };

  const handleMouseLeave = () => {
    setIsMouseOver(false); // Marca que o mouse saiu do item
  };

  // Função chamada quando o mouse sai do item pai ou submenu
  const teste = () => {
    if (isMouseOver === false) {
      setTimeout(function () {
        setHoveredModule(null); // Fecha o submenu após 1s se o mouse não estiver sobre ele
      }, 1000);
    }
  };

  // Observa mudanças no estado do mouse para executar o teste (ocultar submenu)
  useEffect(() => {
    teste();
  }, [isMouseOver, isMouseOverTwo]);

  const handleNestedMouseEnter = (id) => {
    setIsMouseOverTwo(true); // Marca que o mouse está sobre o submenu
    setHoveredModule(id); // Garante que o submenu continue visível
  };

  const handleNestedMouseLeave = (id) => {
    setIsMouseOverTwo(false); // Marca que o mouse saiu do submenu
    setHoveredModule(null); // Fecha o submenu
  };

  //-----------------------------------------CONTROLA O FULL SCREEN--------------------------//


  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.log(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };





  //---------------------IMAGEM DE CARREGANDO-----------//
  const [abaAtiva, setAbaAtiva] = useState("");
  const [loadingImage, setLoadingImage] = useState(null);

  const imagens = [logo1, logo2, logo3, logo4, logo5];

  const trocarAbaComImagem = (novaAba) => {
    const imagemAleatoria = imagens[Math.floor(Math.random() * imagens.length)];
    setLoadingImage(imagemAleatoria);

    setTimeout(() => {
      setLoadingImage(null);
      setAbaAtiva(novaAba);
    }, 1000);
  };

  useEffect(() => {
    trocarAbaComImagem("painel"); // define o nome da aba ativa
  }, []);

  //-------------------------------------------------------------------//

  return (
    <>
      {loadingImage || abaAtiva === "" ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100%",
            textAlign: "center",
          }}
        >
          <img
            src={loadingImage}
            alt="Carregando..."
            style={{
              width: 600,
              height: "auto",
              animation: "zoomIn 0.8s ease-out forwards",
            }}
          />
          <style>
            {`
                  @keyframes zoomIn {
                    from {
                      opacity: 0;
                      transform: scale(0.8);
                    }
                    to {
                      opacity: 1;
                      transform: scale(1);
                    }
                  }
                `}
          </style>
        </div>
      ) : (
        <Geral>


          <Div>
            <Frame currentUrl={currentUrl} loading={loading} setLoading={setLoading} />
          </Div>

          {filteredModulos.map((mod) => (
            !isOpen && (
              <DivExterna
                key={mod.ID_MODULO}
                style={{
                  color: '#fff',
                  position: 'fixed',
                  left: `${elementPosition.left + 60}px`,
                  top: `${elementPosition.top - 7}px`,
                  zIndex: '999',
                }}
                onMouseEnter={() => handleMouseEnter(mod.ID_MODULO)}
                onMouseLeave={() => handleNestedMouseLeave()}
              >
                {hoveredModule === mod.ID_MODULO && (
                  <ListItemEst>
                    <h4 onClick={() => handleItemClick(mod.ID_MODULO)}>
                      {getIconComponent(mod.ICONE)
                        ? React.createElement(getIconComponent(mod.ICONE))
                        : 'Ícone não encontrado'}{' '}
                      {mod.DESC_MODULO}
                    </h4>

                    <NestedListEst
                      onMouseEnter={() => handleNestedMouseEnter(mod.ID_MODULO)}
                      onMouseLeave={() => handleNestedMouseLeave()}
                      style={{ backgroundColor: 'transparent' }}
                    >
                      {filteredPaginas
                        .filter((pag) => pag.ID_MODULO === mod.ID_MODULO)
                        .map((pag) => (
                          <li key={pag.ID_PAGINA} onClick={() => handleUrlClick(pag)}>
                            {pag.DESC_PAGINA}
                          </li>
                        ))}
                    </NestedListEst>
                  </ListItemEst>
                )}
              </DivExterna>
            )
          ))}



          <DivLayout isOpen={isOpen}>
            <div>
              <Divbutton>
                <ToggleButton onClick={toggleSidebar} style={{ backgroundColor: 'transparent' }}>
                  {isOpen ? (
                    <>
                      <ButtonSide2
                        onClick={toggleInicio}
                        title="Tela inicial"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        {isOpen ? (
                          <>
                            <IoMdArrowRoundBack size={28} /> Inicio
                          </>
                        ) : (
                          <IoMdArrowRoundBack size={28} />
                        )}
                      </ButtonSide2>
                      <MdOutlineClose color="red" size={28} />
                    </>
                  ) : (
                    <FaBars />
                  )}
                </ToggleButton>
              </Divbutton>

              <ul style={{ paddingTop: '10px' }}>
                {filteredModulos.map((mod) => (
                  <ListItem
                    key={mod.ID_MODULO}
                    onClick={() => toggleModule(mod.ID_MODULO)}
                    onMouseEnter={(event) => handleMouseEnter(mod.ID_MODULO, event)}
                    onMouseLeave={() => handleMouseLeave()}
                  >
                    <h4>
                      {getIconComponent(mod.ICONE)
                        ? React.createElement(getIconComponent(mod.ICONE))
                        : 'Ícone não encontrado'}{' '}
                      {isOpen && mod.DESC_MODULO}
                    </h4>

                    {isOpen && openModules[mod.ID_MODULO] && (
                      <NestedList>
                        {filteredPaginas
                          .filter((pag) => pag.ID_MODULO === mod.ID_MODULO)
                          .map((pag) => (
                            <li key={pag.ID_PAGINA} onClick={() => handleUrlClick(pag)}>
                              {pag.DESC_PAGINA}
                            </li>
                          ))}
                      </NestedList>
                    )}
                  </ListItem>
                ))}
              </ul>
            </div>
            <Divbuttons>

              <ButtonSide2 onClick={toggleFullscreen} title="Tela cheia" style={{ backgroundColor: "transparent" }}>

                {isOpen ? <><SlSizeFullscreen /> Tela cheia</> : <SlSizeFullscreen />}

              </ButtonSide2>


              {isOpen ? (
                <>
                  <>
                    {(tipoUsuario === 'G' || tipoUsuario === 'A') && (
                      <ButtonSide2 onClick={handleAcessos} title="Acessos" style={{ backgroundColor: "transparent" }}>
                        <FaAddressCard /> Acessos
                      </ButtonSide2>

                    )}
                  </>
                  <>
                    {(tipoUsuario === 'A') && (
                      <ButtonSide23 onClick={handleEquipamentosServico} title="Cadastro Módulos" style={{ backgroundColor: "transparent" }}>
                        <FaLink /> Links
                      </ButtonSide23>

                    )}
                  </>
                  <>
                    {(tipoUsuario === 'A') && (
                      <ButtonSide23 onClick={handleUsuarios} title="Cadastro Usuários" style={{ backgroundColor: "transparent" }}>
                        <FaUser /> Usuários
                      </ButtonSide23>

                    )}
                  </>



                </>


              ) : null}


            </Divbuttons>

          </DivLayout>


        </Geral>
      )}
      <GlobalStyle />
      <ToastContainer autoClose={2500} position={toast.POSITION.BOTTOM_LEFT} style={{ width: '400px', fontSize: '22px' }} />
    </>
  );
}

export default App;
